import * as THREE from 'three';
import * as marietta from '../../../';
import { MasterItemCollection } from '../../../webcad/collection';
import { MonicaObject } from '../../../webcad/item';
import { ThreeView } from "../View3dWebCad";
import { ModelLoadSystem } from '../WebCad3dModelLoadSystem';

export class ChangePointFloor {

    constructor(private floor: THREE.Object3D) {
    }

    public setMaterial(index: number) {
        this.setTexture(ThreeView.get().matmgr.me.materials().floorTexes[index]);
    }

    public setMaterialByName(name: string) {
        const texture = [
            ...ThreeView.get().matmgr.me.materials().floorTexes,
            ...ThreeView.get().matmgr.me.materials().tatamiTexes
        ].find((_texture) => {
            return name == _texture.name;
        });
        this.setTexture(texture);
    }

    private setTexture(texture: THREE.Texture) {
        if (!texture) return;
        const mesh = <THREE.Mesh>this.floor;
        if (!mesh.isMesh) return;
        if (Array.isArray(mesh.material)) {
            ;
        } else {
            const material = <THREE.MeshStandardMaterial>mesh.material.clone();
            material.map = texture;
            mesh.material = material;

            marietta.webcad.WebCADGlobal.itemManager.updateFloorMaterial(this.floor.userData.guid, texture.name);
        }
    }

    public setToEndItem( info:MasterItemCollection ) {
        marietta.webcad.WebCADGlobal.itemManager.updateFloorEndItem(this.floor.userData.guid, info );
    }
    public getEndItem():MasterItemCollection{
        return marietta.webcad.WebCADGlobal.itemManager.getFloorEndItem(this.floor.userData.guid );
    }
    public get2D():MonicaObject{
        return marietta.webcad.WebCADGlobal.itemManager.getFloorParentItem( this.floor.userData.guid );
    }
    public getTargetGuid():string{
        return this.floor.userData.guid;
    }
}
